var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "pdl" },
    [
      _c(
        "div",
        {
          staticClass: "btn",
          on: {
            click: function ($event) {
              return _vm.openModal()
            },
          },
        },
        [_vm._v("添加权限人员")]
      ),
      _c(
        "el-table",
        {
          attrs: {
            border: "",
            "header-cell-class-name": "tableHeader",
            data: _vm.tableData,
          },
        },
        [
          _c("el-table-column", {
            attrs: { label: "人员编码", prop: "userCode" },
          }),
          _c("el-table-column", {
            attrs: { label: "人员账号", prop: "userName" },
          }),
          _c("el-table-column", {
            attrs: { label: "人员名称", prop: "fullName" },
          }),
          _c("el-table-column", {
            attrs: { label: "职位编码", prop: "positionCode" },
          }),
          _c("el-table-column", {
            attrs: { label: "职位名称", prop: "positionName" },
          }),
          _c("el-table-column", {
            attrs: { label: "所属组织编码", prop: "orgCode" },
          }),
          _c("el-table-column", {
            attrs: { label: "所属组织名称", prop: "orgName" },
          }),
        ],
        1
      ),
      _c("SelectConfig", {
        ref: "selectConfig",
        on: { onGetSelect: _vm.onGetSelect },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }